import { createContext } from 'react';

export type ITrackedUtmCampaignContextValue = {
  campaign?: string;
  medium?: string;
  source?: string;
  term?: string;
  content?: string;
};

export const TrackedUtmCampaignContext = createContext<
  ITrackedUtmCampaignContextValue | undefined
>(undefined);
